function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWolontariatIlustracjaOkrag = function SvgWolontariatIlustracjaOkrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 99.38 99.38"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h99.38v99.38H0z",
    style: {
      fill: "#d3c2ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 49.69c0-19.41 14.46-33.62 34.36-33.62s34.36 14.21 34.36 33.62-15.33 33.62-34.36 33.62-34.36-14.09-34.36-33.62m34.36 19.53c10.51 0 18.66-7.54 18.66-19.53s-8.16-19.53-18.66-19.53-18.66 8.03-18.66 19.53 8.16 19.53 18.66 19.53",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgWolontariatIlustracjaOkrag;